module.exports = __webpack_public_path__ + "img/Desk Stationary A43.d9b005cd.jpg";